import { Col, Row } from "antd";
import React from "react";
import { Link } from "react-router-dom";
import { Product, shopService } from "../../services/shopService.ts";
import ProductPreview from "../products/ProductPreview.tsx";
import useBreakpoints from "../../hooks/useBreakpoints.ts";

const SexView = ({sex, collectionId}) => {
  const breakpoint = useBreakpoints();
  const isMobile = ["xs"].includes(breakpoint);
  const [collectionProducts, setCollectionProducts] = React.useState<Product[]>();

  React.useEffect(() => {
    shopService.getSexBasedProducts(sex, collectionId).then(setCollectionProducts);
  }, [sex, collectionId]);

  return (
    <Row>
      {collectionProducts &&
        collectionProducts.map(
          (p) =>
            p.productImages &&
            p.productImages.length > 0 && (
              <Col span={isMobile ? 12 : 6}>
                <Link to={`/products/${p.productId}`}>
                  <ProductPreview key={p.productId} product={p} />
                </Link>
              </Col>
            )
        )}
    </Row>
  );
};

export default SexView;
